import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App.tsx";
import "./assets/styles/app.scss";
import "./index.css";
import { ResourcesProvider } from "./stores/resourcesContext.tsx";
import { globalConfig } from "./config/globalConfig.ts";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={globalConfig.googleClientId}>
      <ResourcesProvider>
        <App />
      </ResourcesProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);
